import { FormattedMessage } from 'react-intl';

type PaymentSummaryProps = {
  currencySymbol: string;
  currencyCode: string;
  totalAmount: string;
};

export const PaymentSummary = ({
  currencySymbol,
  currencyCode,
  totalAmount,
}: PaymentSummaryProps) => (
  <>
    <h2 className="mb-0">
      <FormattedMessage
        id="payment.order.details.payment"
        defaultMessage="Payment"
        description="Order payment"
      />
    </h2>

    <dl className="attribute-list">
      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.amount"
            defaultMessage="Amount"
            description="Total amount"
          />
        </dt>
        <dd>{`${currencySymbol}${totalAmount} ${currencyCode}`}</dd>
      </div>
    </dl>
  </>
);
